module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Black.aa4b73e3.ttf";